module.exports = __webpack_public_path__ + "img/small_tree_light.44f20815.png";